export enum QuoteItemType {
  Required = 'required',
  Optional = 'optional',
}
